<template>
    <div v-show="loaded == false">
        <img :src="placeholder" />
    </div>
    <div id="overlay" style="width: 100%; height: 100vh; position: fixed; top: 0; left: 0; background: rgba(0, 0, 0, 0.3); z-index: 99;" v-show="loading == true">
        <div class="lds-dual-ring"></div>
    </div>
    <div v-show="loaded == true">
        <div class="col-md-7">
            <strong>Cart > Delivery method > Information > Payment</strong>
            <Shipping :edit-mode="false"></Shipping>
            <Contact @setLoadingFromChild="loadingMessageReceivedFromChild"></Contact>
            <Payment @setLoadingFromChild="loadingMessageReceivedFromChild" :showTerms="showTerms" :showPrivacy="showPrivacy"></Payment>
        </div>
        <div class="cart col-md-5">
            <CartTable :edit-mode="false" :summary-mode="false"></CartTable>
        </div>
    </div>
</template>

<script>
    import cartMixin from '../../mixins/cart-mixin.js';
    import generalMixin from '../../mixins/general.js';
    import CartTable from '@/components/CartTable.vue';
    import Shipping from '@/components/Checkout-Shipping.vue';
    import Contact from '@/components/Checkout-Contact.vue';
    import Payment from '@/components/Checkout-Payment.vue';
    export default {
        name: 'Checkout',
        mixins: [cartMixin, generalMixin],
        components: {
            CartTable,
            Shipping,
            Contact,
            Payment
        },
        data: function () {
            return {
                errorContactInfo: '',
                proceedContactInfoButtonClicked: false,
                CountryCode: window.countryCode,
                Country: window.country,
                DivisionId: window.divisionCode,
                culture: window.culture,
                completeInProgress: false,
                loaded: false,
                loading: true,
                placeholder: window.cdn + '/Images/Shared/Shop/cart_placeholder.svg',
                showTerms: true,
                showPrivacy: false
            }
        },
        compatConfig: { MODE: 3 },
        beforeMount() {
            var that = this;
            this.getCartSummary(true, function () { that.loaded = true; that.loading = false;});
        },
        methods: {
            loadingMessageReceivedFromChild(value) {
                this.loading = value;
            }
        },
        computed: {
            // See cartMixin
        },
        created() {
            this.showTerms = document.getElementById('vue-checkout').dataset.showterms == 'true';
            this.showPrivacy = document.getElementById('vue-checkout').dataset.showprivacy == 'true';
        }
    }
</script>
